export default __webpack_public_path__ + "87a9ccb.png";